module.exports = __webpack_public_path__ + "static/media/taste-of-weight-loss.57b494a6.pdf";